import React from "react";
import { Modal, Button, FormInput } from "@/components/ui";
import { Package } from "lucide-react";

export const RestockModal = ({ restockItem, onClose, restockQty, setRestockQty, onRestock, submitting }) => (
  <Modal isOpen={!!restockItem} onClose={onClose} title="Restock Item" size="sm">
    {restockItem && (
      <div className="space-y-6 pt-2">
        <div className="bg-[#f0f7ff] rounded-2xl p-6 border border-blue-50 relative overflow-hidden group">
          <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity">
            <Package size={80} />
          </div>
          <div className="relative">
            <div className="text-xl font-black text-slate-800 tracking-tight mb-3">
              {restockItem.itemName || restockItem.name}
            </div>
            <div className="flex gap-6">
              <div className="flex flex-col">
                <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-0.5">Current Stock</span>
                <span className="text-sm font-black text-brand-blue uppercase">
                  {restockItem.availableQty || restockItem.quantity || 0} {restockItem.unit || restockItem.units || 'Units'}
                </span>
              </div>
              <div className="flex flex-col border-l border-blue-100 pl-6">
                <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-0.5">Min. Level</span>
                <span className="text-sm font-black text-blue-500 uppercase">
                  {restockItem.minQty || 0} {restockItem.unit || restockItem.units || 'Units'}
                </span>
              </div>
            </div>
          </div>
        </div>

        <FormInput 
          label={`Quantity to Add (${restockItem.unit || restockItem.units || 'Units'})`}
          type="number"
          value={restockQty}
          onChange={e => setRestockQty(e.target.value)}
          placeholder="0"
          autoFocus
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onRestock(restockItem, restockQty);
            }
          }}
        />

        <div className="flex gap-3 pt-2">
          <Button variant="secondary" fullWidth onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" fullWidth onClick={() => onRestock(restockItem, restockQty)} isLoading={submitting}>
            Confirm
          </Button>
        </div>
      </div>
    )}
  </Modal>
);
